import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/svg/5a3436bd5fabb67d5b4db2b6a90371b1.svg")